module.exports = __webpack_public_path__ + "static/img/quan_4.a928f19a.png";